import "intersection-observer";
import { useEffect, useState } from "react";

export function useIntersectionObserver(ref, opts) {
  const [intersect, setIntersect] = useState(false);
  useEffect(() => {
    let mounted = true;
    function callback(entries) {
      if (mounted) {
        entries.forEach((entry) => {
          setIntersect(entry.isIntersecting);
        });
      }
    }

    const observer = new IntersectionObserver(callback, opts);
    if (!ref.current) {
      return;
    }
    observer.observe(ref.current);

    return () => {
      mounted = false;
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref.current]);
  return intersect;
}
